<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-row>
      <v-col cols="12">
        <v-card-title>
          User Lists
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="3" md="2">
            <v-autocomplete
                v-model="active"
                :items="statuses"
                item-text="text"
                item-value="value"
                required
                label="Select User Status"
                outlined
                dense
                chips
                hide-details
                @change="change_status"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <template>
              <v-text-field
                  v-model="search"
                  prepend-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                  outlined
              ></v-text-field>
            </template>
          </v-col>
          <v-col cols="12" sm="6" md="1">
            <template>
              <v-row align="center" justify="space-around">
                <v-btn depressed color="info" @click="addItem">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-row>
            </template>
          </v-col>
        </v-card-title>
        <v-card>
          <v-data-table
              :headers="headers"
              :items="users"
              class="elevation-1"
              :search="search"
              dense
              mobile-breakpoint="0"
              :loading="loading_status"
              loading-text="Loading... Please wait"
          >
            <template v-slot:item.active="{ item }">
              <v-chip
                  v-if="item.active == 1"
                  dark
                  color="green"
                  label
                  outlined
                  small
              >Active
              </v-chip>
              <v-chip
                  v-if="item.active == 0"
                  dark
                  color="red"
                  label
                  outlined
                  small
              >Inactive
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top v-if=" specialPower === '1'">
                <template v-slot:activator="{on}">
                  <v-chip
                      @click="editItem(item)"
                      dark
                      v-on="on"
                      class="ma-2"
                      color="orange"
                      label
                      outlined
                      small
                  >
                    <v-icon> mdi-pencil</v-icon>
                  </v-chip>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <template>
      <div class="text-center">
        <v-dialog v-model="addEditModal" width="700">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2"> {{ modalLabel }}</v-card-title>
            <v-card-text>
              <v-row class="mt-2">
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="submitData.first_name"
                    label="First Name"
                    required
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="submitData.last_name"
                    label="Last Name"
                    required
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="submitData.email"
                    label="Email"
                    required
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="submitData.company"
                    label="Company Name"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="submitData.phone"
                    label="Phone"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                      v-model="submitData.role_id"
                      :items="roles"
                      item-value="id"
                      item-text="name"
                      label="Select Role"
                      outlined
                      dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="password"
                    :label="passwordLabel"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="password_confirmation"
                    :label="confirmPasswordLabel"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                      v-model="submitData.active"
                      :items="statuses"
                      item-value="value"
                      item-text="text"
                      label="Select Status"
                      outlined
                      dense
                  ></v-select>
                </v-col>
              </v-row>
              <div v-bind:class="isMemberGroupBlock">
                <label for=""><h2>Member of Group</h2></label>
                <div v-for="(group, index) in groups" :key="index">
                  <v-checkbox
                      v-model="submitData.user_groups"
                      :label="group.name"
                      :value="group.id"
                  ></v-checkbox>
                  <br>
                </div>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" @click="dialog()"> Cancel</v-btn>
              <v-btn color="primary" @click="dataSubmit"> Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

    </template>
  </div>
</template>

<style scoped>
v-col{
  line-height: 2px;
}
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";


export default {
  data() {
    return {
      search: "",
      isMemberGroupBlock: 'd-none',
      addEditModal: false,
      passwordLabel: 'Password',
      confirmPasswordLabel: 'Confirm Password',
      modalLabel: null,
      loading_status: true,
      status: ["Active", "Inactive"],
      password: null,
      password_confirmation: null,
      user_id: localStorage.getItem('userId'),
      specialPower: localStorage.getItem("specialPower"),
      groups: [],
      selectedGroups: [2,5],
      login_user_id: localStorage.getItem("userId"),
      headers: [
        {text: "ID", align: "start", value: "id",},
        {text: "Name", value: "full_name"},
        {text: "Phone", value: "phone"},
        {text: "Email", value: "email"},
        {text: "Status", value: "active"},
        {text: "Role", value: "role.name"},
        {text: "Created By", value: "user.full_name"},
        {text: "Action", value: "actions", sortable: false},
      ],
      submitData: {
        id: '',
        first_name: '',
        last_name: '',
        email: '',
        company: '',
        phone: '',
        role_id: '',
        active: '',
        user_groups: []
      },
      active: 1,
      statuses: [
        { text: 'Active', value: 1 },
        { text: 'Inactive', value: 0 },
      ],
      users: [],
      roles: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        }, {
          text: "Users",
          disabled: false,
          href: "user-list",
        }, {
          text: "User List",
          disabled: true,
          href: "",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,

    };
  },
  // Fetches posts when the component is created.
  created() {
    this.getLoginUserGroupAdminCheck()
    this.initialize();
  },
  methods: {
    initialize() {
      this.getUserList();
      this.getGroupList();
      this.getRoleList();
    },
    change_status(){
      this.getUserList()
    },
    getUserList() {
      atshq
          .get("users/user?active=" + this.active)
          .then((response) => {
            this.users = response.data.data;
            this.loading_status = false;
          })
          .catch((e) => {
            this.$noty.error(e.message);
            this.loading_status = false;
          });
    },
    getGroupList() {
      atshq.get("users/group-list")
          .then((response) => {
            this.groups = response.data.groups
          }).catch((e) => {
        this.$noty.error(e.message);
      });
    },
    getLoginUserGroupAdminCheck() {
      atshq.get("users/login-user-id/" + this.login_user_id)
          .then((response) => {
            if (!response.data.adminCheck) {
              this.isMemberGroupBlock = 'd-none'
            }
          }).catch((e) => {
        this.$noty.error(e.message);
      });
    },
    getRoleList() {
      atshq
          .get("users/roles")
          .then((response) => {
            this.roles = response.data.roles;
          })
          .catch((e) => {
            this.$noty.error(e.response.data.message);
          });
    },
    dataSubmit() {
      let dataSubmitUrl = this.submitData.id ? "users/user/"+ this.submitData.id : "users/user";
      if (this.submitData.id) {
        atshq.put(dataSubmitUrl, {
          submitData: this.submitData,
          password: this.password,
          password_confirmation: this.password_confirmation,
          login_user_id: this.login_user_id,
        }).then((response) => {
          this.$noty.success(response.data.message);
          this.addEditModal = false;
          this.initialize()
        }).catch((e) => {
          this.$noty.error(e.response.data.message);
        });
      } else {
        atshq.post(dataSubmitUrl, {
          submitData: this.submitData,
          password: this.password,
          password_confirmation: this.password_confirmation,
        }).then((response) => {
          this.$noty.success(response.data.message);
          this.addEditModal = false;
          this.initialize()
        }).catch((e) => {
          this.$noty.error(" " + e.response.data.message);
        });
      }
    },
    addItem() {
      this.modalLabel = 'Add User'
      this.addEditModal = true
      this.submitData.id = ''
      this.submitData.first_name = ''
      this.submitData.last_name = ''
      this.submitData.email = ''
      this.submitData.company = ''
      this.submitData.phone = ''
      this.submitData.role_id = ''
      this.submitData.active = ''
      this.password = ''
      this.password_confirmation = ''
      this.passwordLabel='Password'
      this.confirmPasswordLabel='Confirm Password'
      this.submitData.user_groups = []
    },
    editItem(item) {
      this.modalLabel = 'Edit User'
      this.addEditModal = true
      this.submitData.id = item.id
      this.submitData.first_name = item.first_name
      this.submitData.last_name = item.last_name
      this.submitData.email = item.email
      this.submitData.company = item.company
      this.submitData.phone = item.phone
      this.submitData.role_id = item.role_id
      this.submitData.active = item.active
      this.password = ''
      this.password_confirmation = ''
      this.passwordLabel='Password (If changing password)'
      this.confirmPasswordLabel='Confirm Password (If changing password)'
      this.submitData.user_groups = []
      item.user_groups.forEach((value) => {
        this.submitData.user_groups.push(value.group_id)
      })
    },
    dialog(){
      this.addEditModal = false
    }
  },
};
</script>